import React from 'react';
import PropTypes from 'prop-types';

Step.propTypes = {
    data: PropTypes.array,
    className: PropTypes.string, // Agrega className a las PropTypes
};

function Step(props) {
    const { data, className } = props; // Desestructura className de props
    return (
        <section className={`tf-section three_step ${className}`}> {/* Usa className aquí */}
            <div className="overlay"></div>
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <div className="tf-title mb46 left" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title">
                                Beneficios de las <br className="show-destop" />
                                Simulaciones Virtuales
                            </h2>
                        </div>
                        <div className="wrap-box">
                            {
                                data.map(item => (
                                    <div key={item.id} className="icon-box-style3">
                                        <div className="icon">
                                            <img src={item.img} alt="" />
                                        </div>
                                        <div className="content">
                                            <h5 className="title">{item.title}</h5>
                                            <p>{item.text}</p>
                                        </div>
                                        <img className="icon_bottom" src={require("../../assets/images/common/Line.png")} alt="" />
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-center">
                        <div className="image pt30">
                            <img src='/assets/cerv/home/01.png' className="move5" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Step;